import React from 'react';

import { CashFlowsValidValues } from 'features/drilldown/cashflows/configurations/cashflow-inputs';

import { DownloadDocumentButton } from 'ui-kit';

import { downloadExcelWorkbookFromJson } from 'utils/excelUtils';

import {
  buildAssumptionRows,
  buildPriceYieldCurveRows,
  priceYieldCurveFileName,
} from './exportPriceYieldCurve';
import { PriceYieldPoint } from './utils';

interface DownloadPriceYieldCurveButtonProps {
  yieldPoints: PriceYieldPoint[];
  spreadPoints: PriceYieldPoint[];
  formValues: CashFlowsValidValues;
  className?: string;
}

// Downloads the rendered price/yield curve as a spreadsheet: one sheet with
// the curve points, one with the scenario assumptions they were computed
// under (ENG-3448). Renders nothing while there is no curve to export.
export const DownloadPriceYieldCurveButton: React.FC<DownloadPriceYieldCurveButtonProps> = ({
  yieldPoints,
  spreadPoints,
  formValues,
  className,
}) => {
  if (yieldPoints.length === 0 && spreadPoints.length === 0) {
    return null;
  }

  const handleDownload = () => {
    downloadExcelWorkbookFromJson(
      [
        { name: 'Price Yield Curve', rows: buildPriceYieldCurveRows(yieldPoints, spreadPoints) },
        { name: 'Assumptions', rows: buildAssumptionRows(formValues) },
      ],
      priceYieldCurveFileName(formValues),
    );
  };

  return (
    <div data-testid="download-price-yield-curve">
      <DownloadDocumentButton
        onClick={handleDownload}
        fileType="excel"
        tooltipText="Download price/yield curve"
        tooltipPosition="left"
        dataTooltipId="download-price-yield-curve"
        className={className}
      />
    </div>
  );
};

export default DownloadPriceYieldCurveButton;
